import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
const Slider = ({
  title,
  children,
  buttonType,
  variant,
  size,
  onAfterOpen,
}) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)

  return (
    <>
      {buttonType === 'dropdown' ? (
        <ReactBootstrap.Dropdown.Item
          variant={variant}
          size={size}
          onClick={() => setIsPaneOpen(true)}
        >
          {title}
        </ReactBootstrap.Dropdown.Item>
      ) : (
        <ReactBootstrap.Button
          variant={variant}
          size={size}
          onClick={() => setIsPaneOpen(true)}
        >
          {title}
        </ReactBootstrap.Button>
      )}
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onAfterOpen={() => (onAfterOpen ? onAfterOpen() : () => {})}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        {children}
      </SlidingPane>
    </>
  )
}

Slider.defaultProps = {
  buttonType: 'button',
  variant: 'dark',
  size: 'size',
}

export default Slider
